import { useTranslation } from "react-i18next";
import { Button, Icon, Input, Loader, Modal } from "semantic-ui-react";

import { useCan } from "components";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { ManufacturerClaimsTable, ManufacturerConfirmRequestModal } from "modules/ManufacturerDashboard/components";
import "modules/ManufacturerDashboard/components/CreateManufacturerRequestModal/CreateManufacturerRequestModal.scss";
import { useConfirmManufacturerRequest } from "modules/ManufacturerDashboard/hooks";

import type { Pin } from "models";

interface CreateManufacturerRequestModalTypes {
  isLoading: boolean;
  claimResults: Pin[];
  onCloseModal: () => void;
  onSearchClaim: (searchTerm: string) => void;
}

export const CreateManufacturerRequestModal = ({ onCloseModal, onSearchClaim, claimResults, isLoading }: CreateManufacturerRequestModalTypes) => {
  const { t } = useTranslation();

  const canSearchClaimNr = useCan(ACL_ACTIVITIES.Search, ACL_RESOURCES.Pin);
  const { createManufacturerRequest, handleRequestReason, closeConfirmModal, selectRequest, isConfirmButtonDisabled, selectedRequest } = useConfirmManufacturerRequest();

  const closeConfirmAndRequestModals = () => {
    closeConfirmModal();
    onCloseModal();
  };

  return (
    <>
      <Modal open size="large">
        <Modal.Header className="Manufacturer__requestModal-header">
          <h3>{t("v8_request_access", "Request Access")}</h3>
          <Button basic size="big" className="Manufacturer__requestModal-header--closeBtn" onClick={onCloseModal}>
            <Icon className="x" />
          </Button>
        </Modal.Header>

        <Modal.Content scrolling>
          <h3>{t("v8_search_by_claim_number", "Search by claim number")}</h3>
          <Input
            disabled={!canSearchClaimNr}
            onChange={e => onSearchClaim(e.target.value)}
            className="Manufacturer__requestModal-content--input"
            icon={<Icon className="magnifying glass" />}
            iconPosition="left"
            placeholder={t("v8_claim_number", "Claim Number")}
          />
          {isLoading && <Loader size="small" />}
          {!!claimResults.length && <ManufacturerClaimsTable claimsResults={claimResults} onSelectRow={selectRequest} />}
        </Modal.Content>
      </Modal>

      <ManufacturerConfirmRequestModal
        onCloseModal={closeConfirmModal}
        showConfirmModal={Boolean(selectedRequest)}
        onHandleRequestReason={handleRequestReason}
        onCreateRequest={() => createManufacturerRequest(closeConfirmAndRequestModals)}
        isConfirmButtonDisabled={isConfirmButtonDisabled}
      />
    </>
  );
};
